import { Controller } from 'stimulus'
import { showLoader, hideLoader } from '../utils/loader'
import Turbolinks from 'turbolinks'

export default class extends Controller {
  static values = {
    url: String,
    confirm: String
  }

  submit(event) {
    event.preventDefault()

    if (this.confirmValue && !confirm(this.confirmValue)) {
      return
    }

    // Show loader
    showLoader()

    // Collect all checkbox data - works for any entity (groups, users, organizations)
    // Only get checkboxes with class 'form-check-input' to avoid hidden fields
    const checkboxes = document.querySelectorAll('input[type="checkbox"].form-check-input[name*="[enabled]"]')

    // Get CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    // Build form data from all checkboxes
    const formData = new FormData()
    checkboxes.forEach(checkbox => {
      // Use the checkbox name directly (e.g., "groups[123][enabled]")
      formData.append(checkbox.name, checkbox.checked ? '1' : '0')
    })

    // Submit via fetch
    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Accept': 'text/html'
      },
      credentials: 'same-origin',  // Ensure cookies are sent and received
      body: formData
    })
    .then(response => {
      if (response.ok) {
        return response.text()
      } else {
        throw new Error('Error updating records')
      }
    })
    .then(() => {
      // Hide loader
      hideLoader()

      // Show success message
      this.showSuccessMessage('Successfully updated')

      // Reload the current URL (preserves filter params from replaceState)
      setTimeout(() => {
        // Find the filter form and trigger a submit to refresh table via AJAX
        const filterForm = document.querySelector('form[data-controller~="form"]')
        if (filterForm) {
          const formController = this.application.getControllerForElementAndIdentifier(filterForm, 'form')
          if (formController && typeof formController.submit === 'function') {
            formController.submit()
            return
          }
        }
        // Fallback: reload with current URL (which should have filters from replaceState)
        window.location.href = window.location.href
      }, 500)
    })
    .catch(error => {
      console.error('Error:', error)
      hideLoader()
      this.showErrorMessage('Error updating records')
    })
  }

  showSuccessMessage(message) {
    this.showAlert(message, 'success')
  }

  showErrorMessage(message) {
    this.showAlert(message, 'danger')
  }

  showAlert(message, type) {
    // Create Bootstrap alert
    const alert = document.createElement('div')
    alert.className = `alert alert-${type} alert-dismissible fade show position-fixed top-0 start-50 translate-middle-x mt-3`
    alert.style.zIndex = '9999'
    alert.style.minWidth = '300px'
    alert.innerHTML = `
      ${message}
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    `
    document.body.appendChild(alert)

    // Auto-dismiss after 3 seconds
    setTimeout(() => {
      alert.classList.remove('show')
      setTimeout(() => alert.remove(), 150)
    }, 2000)
  }
}
